import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ dataComponents: { drawer } }: ComposedTheme) => {
  const { filters } = drawer;

  return {
    accordionContent: {
      overflow: 'visible',
    },
    filterableWrapper: {
      flex: '1',
      overflowY: 'auto',
      padding: [0, 25, 0, 15],
      '&::-webkit-scrollbar': {
        width: 10,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: drawer.scrollbarColor,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: drawer.scrollbarBackground,
        marginTop: 20,
      },
      '& ul': {
        maxHeight: 300,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: 10,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: drawer.scrollbarColor,
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: drawer.scrollbarBackground,
          marginTop: 20,
        },
      },
    },
    clearBtn: {
      margin: [0, 0, 0, 6],
      color: filters.clearButtonTextColor,
    },
    clearFilter: {
      '& svg': {
        fill: filters.clearButtonTextColor,
        height: 12,
        width: 12,
      },
      alignItems: 'center',
      display: 'flex',
      marginLeft: 10,
    },
    header: {
      fontFamily: filters.text.fontFamily,
      fontSize: filters.text.fontSize,
      fontWeight: filters.text.fontWeight,
      textTransform: 'uppercase',
      display: 'flex',
    },
    panelHeader: {
      '& svg': {
        fill: filters.text.color,
        height: 16,
        width: 16,
      },
    },
    panelHeaderMessage: {
      margin: 0,
      fontFamily: filters.text.fontFamily,
      fontSize: filters.text.fontSize,
      fontWeight: filters.text.fontWeight,
      color: filters.text.color,
    },
    hiddenField: {
      '& svg': {
        fill: filters.hidden.color,
        marginRight: 5,
      },
      fontFamily: filters.hidden.fontFamily,
      fontSize: filters.hidden.fontSize,
      fontWeight: filters.hidden.fontWeight,
      textTransform: filters.hidden.textTransform,
      color: filters.hidden.color,
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'flex-end',
    },
  };
};

export default createUseStyles(styles);
